var CustomerProfile = (function () {
    var companyrID = 0;
    var customer = '';
    var date = '';
    var date2 = '';
    var invoiceItems = '';
    var payment = '';
    var category = '';
    var advance = '';

    var getCompanyIDProfile = function () {
        return companyrID;
    }

    var getCustomerProfile = function () {
        return customer;
    };

    var getDateProfile = function () {
        return date;
    }

    var getDate2Profile = function () {
        return date2;
    }

    var getInvoiceItemsProfile = function () {
        return invoiceItems;
    }

    var getPaymentProfile = function () {
        return payment;
    }

    var getCategoryProfile = function () {
        return category;
    }

    var getAdvanceProfile = function () {
        return advance;
    }

    var setCompanyIDProfile = function (ID) {
        companyrID = parseInt(ID);
    }

    var setCustomerProfile = function (data) {
        customer = data;
    };

    var setDateProfile = function (cDate) {
        date = cDate;
    }

    var setDate2Profile = function (cDate2) {
        date2 = cDate2;
    }

    var setInvoiceItemsProfile = function (iData) {
        invoiceItems = iData;
    }

    var setPaymentProfile = function (iPayment) {
        payment = iPayment;
    }

    var setCategoryProfile = function (iCategory) {
        category = iCategory;
    }

    var setAdvanceProfile = function (advanceList) {
        advance = advanceList;
    }

    return {
        getCompanyID: getCompanyIDProfile,
        getCustomer: getCustomerProfile,
        getDate: getDateProfile,
        getDate2: getDate2Profile,
        getInvoiceItems: getInvoiceItemsProfile,
        getPayment: getPaymentProfile,
        getCategory: getCategoryProfile,
        getAdvance: getAdvanceProfile,
        setCompanyID: setCompanyIDProfile,
        setCustomer: setCustomerProfile,
        setDate: setDateProfile,
        setDate2: setDate2Profile,
        setInvoiceItems: setInvoiceItemsProfile,
        setPayment: setPaymentProfile,
        setCategory: setCategoryProfile,
        setAdvance: setAdvanceProfile
    }
})();

export default CustomerProfile;